"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/KGFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_122)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_122`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.96484 0H30.0352V24H-5.96484V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9999 23.9579C18.6157 23.9579 23.9789 18.5947 23.9789 11.9789C23.9789 5.36316 18.6157 0 11.9999 0C5.38415 0 0.0209961 5.36316 0.0209961 11.9789C0.0209961 18.5947 5.38415 23.9579 11.9999 23.9579Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M20.8702 11.979L17.2492 13.6842L19.179 17.193L15.2422 16.4421L14.7439 20.4141L12.0001 17.4877L9.2562 20.4141L8.75795 16.4421L4.82111 17.193L6.75093 13.6842L3.12988 11.979L6.75093 10.2737L4.82111 6.75792L8.75795 7.51581L9.2562 3.53687L12.0001 6.46318L14.7439 3.53687L15.2422 7.51581L19.179 6.75792L17.2492 10.2737L20.8702 11.979Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M12.0983 17.0035C14.8733 17.0035 17.1229 14.7539 17.1229 11.9789C17.1229 9.20392 14.8733 6.95435 12.0983 6.95435C9.3233 6.95435 7.07373 9.20392 7.07373 11.9789C7.07373 14.7539 9.3233 17.0035 12.0983 17.0035Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.06668 11.9789C8.91931 11.9789 8.77896 11.9859 8.63159 11.9999C8.63861 12.842 8.94036 13.6069 9.44563 14.2105C9.71229 13.4876 10.1123 12.835 10.6176 12.2666C10.1333 12.0771 9.61405 11.9789 9.06668 11.9789ZM10.9333 15.242C11.2983 15.3754 11.6912 15.4455 12.0983 15.4455C12.5053 15.4455 12.8983 15.3754 13.2632 15.242C13.0667 14.4631 12.6526 13.7683 12.0983 13.221C11.5439 13.7683 11.1298 14.4631 10.9333 15.242ZM15.1018 10.2455C14.5053 9.20694 13.3825 8.51221 12.0983 8.51221C10.814 8.51221 9.69826 9.20694 9.09475 10.2455C10.1895 10.2526 11.214 10.5473 12.0983 11.0596C12.9825 10.5473 14.007 10.2455 15.1018 10.2455ZM13.579 12.2666C14.0842 12.828 14.4842 13.4876 14.7509 14.2105C15.2562 13.614 15.5579 12.842 15.5649 11.9999C15.4246 11.9859 15.2772 11.9789 15.1298 11.9789C14.5895 11.9789 14.0632 12.0771 13.579 12.2666Z",
					fill: "#FFDA44"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_122`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as KGFlag };
